/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_System_ReadonlyInputs */

const cs_templates_system_readonly = /** @type {(inputs: Templates_System_ReadonlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systémové šablony jsou jen pro čtení. Vytvořte kopii pro úpravy.`)
};

const en_templates_system_readonly = /** @type {(inputs: Templates_System_ReadonlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System templates are read-only. Fork to edit.`)
};

/**
* | output |
* | --- |
* | "System templates are read-only. Fork to edit." |
*
* @param {Templates_System_ReadonlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_system_readonly = /** @type {((inputs?: Templates_System_ReadonlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_System_ReadonlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_system_readonly(inputs)
	return cs_templates_system_readonly(inputs)
});